import * as React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import HealthOverviewIcon from '@mui/icons-material/HealthAndSafety';
import WarningIcon from '@mui/icons-material/Warning';

import styles from './main.styles.js';
import Person2Icon from '@mui/icons-material/Person2';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles.css';
import BlindIcon from '@mui/icons-material/Blind';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import HomeIcon from '@mui/icons-material/Home';
import useStore, { updateScreenWidth } from '../Store/Store.js';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import moment from 'moment';
import ProfileDropDown from './components/ProfileDropDown.jsx';
import Logo from '../images/logo.png';
import NotificationDropDown from './components/NotificationDropDown.jsx';
import SearchBox from '../components/SearchBox.jsx';
import IconButton from '../components/IconButton.jsx';
import { ICON_BUTTON_TYPE } from '../constants/index.js';
import { Dialog, Slide } from '@mui/material';

const CAN_CARE_LIST = [
  {
    icon: <HomeIcon />,
    title: 'Dashboard',
    path: '/main',
  },
  {
    icon: <HealthOverviewIcon />,
    title: 'Health Overview',
    path: '/health-overview',
  },
  {
    icon: <CalendarMonthIcon />,
    title: 'Calendar',
    path: '/calendar',
  },
  // {
  //   icon: <BlindIcon />,
  //   title: 'Add a new Cane',
  //   path: '/add-device',
  // },
  {
    icon: <MedicalServicesIcon />,
    title: 'Pill reminder',
    path: '/medications',
  },
  {
    icon: <PeopleIcon />,
    title: 'Care team',
    path: '/caregivers',
  },
  {
    icon: <VolunteerActivismIcon />,
    title: 'Care recipients',
    path: '/care-recipients',
  },
  {
    icon: <WarningIcon />,
    title: 'CAN Emergency',
    path: '/can-emergency',
  },
  {
    icon: <ChatIcon />,
    title: 'Chats',
    path: '/chats',
  },
  {
    icon: <Person2Icon />,
    title: 'My Profile',
    path: '/edit-profile',
  },
  {
    icon: <VideoSettingsIcon />,
    title: 'CAN Videos',
    path: '/can-videos',
  },
];

const SideBar = ({ height, handleClickNav, mobile = false, setSidebar }) => {
  const width = useStore((state) => state.screenWidth);
  const location = useLocation();

  return (
    <div
      className="sidebar"
      style={{
        width: mobile ? '100%' : width > 1350 ? '12%' : '40px',
        height: mobile ? '100vh' : width > 1350 ? '100vh' : height,
        display: mobile ? 'flex' : width > 850 ? 'flex' : 'none',
      }}
    >
      <div className="frame">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '85%' }}>
          <div className="frame-1">
            <img src={Logo} className="mask-group" alt="logo" />
          </div>
          {mobile && (
            <div className="frame-1">
              <IconButton type={ICON_BUTTON_TYPE.close} onClick={setSidebar} />
            </div>
          )}
        </div>

        <div className="frame-2">
          {CAN_CARE_LIST.map(({ icon, title, path }, idx) => (
            <div
              className="component-5"
              style={{
                background: location.pathname === path ? '#f5f5f7' : '#fff',
                width: mobile ? '80%' : width > 1350 ? '180px' : '38px',
              }}
              key={idx}
              onClick={() => handleClickNav(path)}
            >
              <div
                className="navbar-icon"
                style={{
                  background: location.pathname === path ? '#277769' : '#f5f5f7',
                  color: location.pathname === path ? '#fff' : 'grey',
                }}
              >
                {icon}
              </div>
              {width > 1350 && <span className="label-health-overview">{title}</span>}
              {mobile && <span className="label-health-overview">{title}</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const NewUserInfo = ({ height = '100vh' }) => {
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const features = useStore((state) => state.features);
  const [sidebar, setSidebar] = React.useState(false);

  const handleClickNav = (path) => {
    setSidebar(false);
    history(path);
  };

  const updateDimensions = () => {
    updateScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <>
      <SideBar height={height} handleClickNav={handleClickNav} />
      <div style={{ padding: '20px', width: '96%' }}>
        <div
          style={{
            display: width > 850 ? 'flex' : 'block',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginLeft: width > 850 ? '17%' : '0%',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {width < 850 && (
              <IconButton
                type={ICON_BUTTON_TYPE.menu}
                style={{ marginRight: '15px' }}
                onClick={() => setSidebar(true)}
              />
            )}
            <div>{features.searchbar && <SearchBox />}</div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginTop: width > 850 ? '0' : '20px' }}>
            {width > 550 && (
              <span style={{ color: '#93939c', marginRight: '10px' }}>
                Today {moment().format('ddd, DD, MMM, YYYY')}
              </span>
            )}
            {features.notification && <NotificationDropDown userId={user?._id} />}
            <ProfileDropDown user={user} />
          </div>
        </div>
      </div>

      <Dialog
        fullScreen
        open={sidebar}
        onClose={() => setSidebar(false)}
        TransitionComponent={Transition}
        style={{ width: '70%' }}
      >
        <SideBar height={height} handleClickNav={handleClickNav} mobile={true} setSidebar={() => setSidebar(false)} />
      </Dialog>
    </>
  );
};

export default NewUserInfo;
